<div class="modal active">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>Subscription List</h2>
      <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  class="active" #form="ngForm">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="table-fields">
                <div style="height: 500px;overflow-y: auto;">
                  <label class="full">Select one or multiple FIRs to receive a notification of any test in that area.</label>
                  <table>
                    <thead>
                    <tr>
                      <th scope="col">
                        Subscribed
                      </th>
                      <th scope="col">FIR</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr mdbTableCol *ngFor="let el of GritProjectService.globalInformation.firs;">
                      <td>
                        <input type="checkbox"
                               (click)="this.toggleFir(el.value)"
                               [checked]="this.subscriptionList.includes(el.value)"/>
                      </td>
                      <td>{{ el.display }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="form.form.valid ? 'blue' : 'gray'"
                    (click)="save()"
                    [disabled]="!form.form.valid">Save</button>
            <a class="gray" href="#" type="reset" value="Cancel">Cancel</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
